import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "searchPeople"
const SearchPeopleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.073 16.841 4.24 4.241a.75.75 0 0 0 1.06 0l.707-.707a.75.75 0 0 0 0-1.06l-4.24-4.241a7.457 7.457 0 1 0-1.768 1.768ZM10.75 7a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Zm3.75 6.563c0-1.036-1.678-1.876-3.75-1.876S7 12.527 7 13.563v.937h7.5v-.938Z"
          />
        </svg>
      }
    </span>
  )
}
export default SearchPeopleIcon
